import { Component, Input, OnInit } from '@angular/core';
import { RentalsUnitedService } from '../..';
import { first } from 'rxjs/operators';
import { AuthenticationService, UserService } from '@app/_services';
import { PropertyService } from '@app/_components/property';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ReportService } from '@app/_components/report';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ApiResponse } from '@app/_models';

@Component({
    selector: 'app-ru-building',
    templateUrl: './ru-building.component.html',
    styleUrls: ['./ru-building.component.css'],
    standalone: false
})
export class RuBuildingComponent implements OnInit
{

  selectedShortTermRental: any;
  buildings: any;
  developments: any = [];

  // data
  apiResponse: ApiResponse;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAction: String;
  formLabels = [];
  formReadOnly = false;
  formAlert: String;
  formTitle: String;
  formErrorMessage: String;

  @Input() ruAccount: any;

  validationMessages = {
    'developmentId': [],
    'addressDevelopmentName': []
  };
  ruAccounts: any[];

  constructor(
    private rentalsUnitedService: RentalsUnitedService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private propertyService: PropertyService,
    private router: Router,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private reportService: ReportService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder) { 
      this.ruAccounts = rentalsUnitedService.ruAccounts;
    }



  ngOnInit(): void
  {
    this.buildForm();
    if(this.ruAccount != undefined){
			const data ={
				ruAccount: this.ruAccount,
			}
			this.loadBuildings(data);
		}else{
			const data ={
				ruAccount: this.form1.value.ruAccount,
			}
			this.loadBuildings(data);
		}
    this.loadDevelopments();
  }

  onFormSubmit()
  {
    if (this.form1.invalid)
    {
      return;
    }
    this.saveBuilding(this.form1.value);
  }

  loadBuildings(data: any)
  {
    this.formLoading = true;
    this.rentalsUnitedService.listBuildings(data)
      .pipe(first())
      .subscribe(
        res =>
        {
          console.log('listBuildings: ' + JSON.stringify(res));
          this.buildings = res.data.buildings.Buildings;
        },
        err =>
        {
          console.log('error In login.component is: ' + JSON.stringify(err));
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'listBuildings Failed', detail: 'We were unable to retrieve your properties: ' + err.message, life: 3000 });
        },
        () => { this.formLoading = false; });
  }


  saveBuilding(building)
  {
    this.formLoading = true;
    this.rentalsUnitedService.saveBuilding(building)
      .pipe(first())
      .subscribe(
        res =>
        {
          console.log('saveBuilding: ' + JSON.stringify(res));
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: '' + res.message, life: 3000 });
          if(this.ruAccount != undefined){
            const data ={
              ruAccount: this.ruAccount,
            }
            this.loadBuildings(data);
          }else{
            const data ={
              ruAccount: this.form1.value.ruAccount,
            }
            this.loadBuildings(data);
          }
        },
        err =>
        {
          console.log('error In login.component is: ' + JSON.stringify(err));
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'listBuildings Failed', detail: 'We were unable to retrieve your properties: ' + err, life: 3000 });
        },
        () => { this.formLoading = false; });
  }

  loadDevelopments()
  {
    this.formLoading = true;
    this.reportService.developmentSummaryList()
      .subscribe(
        res =>
        {
          // console.log('developmentSummaryList SUCCESS: ' + JSON.stringify(res.data.developmentSummaryList));
          this.developments = res.data.developmentSummaryList;
          this.developments.unshift({});
        },
        err =>
        {
          console.log('developmentSummaryList FAIL: ' + JSON.stringify(err));
          this.messageService.add({ severity: 'error', summary: 'loadDevelopments Failed', detail: 'We were unable to retrieve your developments: ' + err.message, life: 3000 });
        },
        () => { this.formLoading = false; });
  }

  buildForm()
  {
    this.form1 = this.formBuilder.group({
      developmentId: ['', Validators.required],
      addressDevelopmentName: ['', Validators.required],
      ruAccount:['test']
    });
  }

  onRUAccount(event)
  {
    // console.log('shortTermRentalSummary ' + JSON.stringify(event.value));
    this.ruAccount = event.value;
    this.ngOnChanges();
  }

  ngOnChanges() {
		
	this.ngOnInit();
}
}
